import hres7deLabels from 'assets/labels/hres7de'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres7deLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        codcours: faker.lorem.word(),
        nam_cours: faker.lorem.word(),
        dteyear: moment().format('YYYY'),
        name: faker.name.findName(),
        codcate: faker.random.number().toString().substr(0, 1),
        numclseq: faker.random.number().toString().substr(0, 1),
        nam_tparg: faker.lorem.word(),
        v_dteinput: faker.lorem.word(),
        dtemonth: moment().format('MM'),
        dtecert: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        destrfu1: faker.lorem.word(),
        status: mockStatus[staappr],
        staappr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codtparg: faker.lorem.word(),
      desc_codtparg: faker.lorem.word(),
      desc_typtrain: faker.lorem.word(),
      codinsts: faker.random.number().toString().substr(0, 1),
      nam_codinsts: faker.lorem.word(),
      codcate: faker.random.number().toString().substr(0, 1),
      desc_codcate: faker.lorem.word(),
      codhotel: faker.lorem.word(),
      nam_codhotel: faker.lorem.word(),
      codinst: faker.random.number().toString().substr(0, 1),
      nam_codinst: faker.lorem.word(),
      flgupdcmp: faker.lorem.word(),
      destrfu1: faker.lorem.word(),
      dtetrst: moment().format('DD/MM/YYYY'),
      dtetren: moment().format('DD/MM/YYYY'),
      numcert: faker.random.number().toString().substr(0, 1),
      qtytrhur: faker.random.number().toString().substr(0, 1),
      dtecert: moment().format('DD/MM/YYYY'),
      amttrexp: faker.random.number().toString().substr(0, 1),
      typtrain: faker.lorem.word(),
      qtyprescr: faker.random.number().toString().substr(0, 1),
      descommt: faker.lorem.word(),
      qtytotscr: faker.random.number().toString().substr(0, 1),
      flgtrevl: faker.lorem.word(),
      dtecntr: moment().format('DD/MM/YYYY'),
      dteexam: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      codexam: faker.random.number().toString().substr(0, 1),
      typexam: '1'
    }
    let mockTab2 = {
      codform: faker.random.number().toString().substr(0, 1),
      desc_codform: faker.lorem.word(),
      destrevl: faker.lorem.word()
    }
    let mockTab2Table2Rows = []
    const mockChoice = [ 'A', 'B', 'C', 'D' ]
    const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
    const mockScore = [ '4', '3', '2', '1' ]
    const mockTab2Table2Total = 4
    for (var d = 1; d <= mockTab2Table2Total; d++) {
      mockTab2Table2Rows.push({
        grditem: d,
        grade: mockChoice[d - 1],
        qtyscor: mockScore[d - 1],
        desc_grditem: mockDescChoice[d - 1],
        definit: ''
      })
    }
    let mockTab2Table1GroupRows = []
    const mockTab2Table1Total = 3
    for (var a = 1; a <= mockTab2Table1Total; a++) {
      let mockTab2Table1ItemRows = []
      const mockTab2Table1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockTab2Table1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGrditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGrditem * mockItemQtywgt
        let mockChoiceFiltered = mockTab2Table2Rows.filter((choice) => {
          return choice.grditem === mockItemGrditem
        })
        let mockGrad = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrad = mockChoiceFiltered[0].grade
        }
        mockTab2Table1ItemRows.push({
          numitem: e,
          desc_numitem: 'description ',
          definit: 'Sub description',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          grditem: mockItemGrditem,
          grade: mockGrad,
          qtywgt: mockItemQtywgt
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab2Table1GroupRows.push({
        numgrup: a,
        desc_numgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        numitem: mockTab2Table1ItemRows
      })
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var i = 1; i <= mockTab3Total; i++) {
      mockTab3Rows.push({
        codinst: faker.lorem.word(),
        desc_codinst: faker.lorem.word(),
        codsubj: faker.lorem.word(),
        desc_codsubj: faker.lorem.word(),
        qtyscore: faker.random.number().toString().substr(0, 1),
        qtyemp: faker.random.number().toString().substr(0, 1),
        destrevl: faker.lorem.word(),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY')
      })
    }
    let mockTab4 = {
      dessummary: faker.lorem.word(),
      desbenefit: faker.lorem.word(),
      descomment: faker.lorem.word()
    }

    return {
      tab1: mockTab1,
      tab2: {
        detail: mockTab2,
        table1: {
          total: mockTab2Table1Total,
          rows: mockTab2Table1GroupRows
        },
        table2: {
          total: mockTab2Table2Total,
          rows: mockTab2Table2Rows
        }
      },
      tab3: {
        total: mockTab3Total,
        rows: mockTab3Rows
      },
      tab4: mockTab4
    }
  },
  detailTab1Popup () {
    let mockDetailTab1Popup = {
      dteexam: moment().format('DD/MM/YYYY'),
      codempid: faker.random.word(),
      desc_codempid: faker.random.word(),
      codexam: faker.random.word(),
      desc_codexam: faker.random.word()
    }
    let mockTab1Rows1 = []
    const mockTab1Total1 = 5
    for (var b = 1; b <= mockTab1Total1; b++) {
      mockTab1Rows1.push({
        numques: b,
        desc_exam: faker.random.word(),
        qtytest: faker.random.number().toString().substr(0, 1),
        qtyscore: faker.random.number().toString().substr(0, 1)
      })
    }
    let mockTab4Rows1 = []
    const mockTab4Total1 = 5
    for (var c = 1; c <= mockTab4Total1; c++) {
      mockTab4Rows1.push({
        numques: c,
        question: faker.random.word(),
        answer: faker.random.word(),
        qtyques: faker.random.number().toString().substr(0, 1),
        qtytest: faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      detail: mockDetailTab1Popup,
      table1: {
        total: mockTab1Total1,
        rows: mockTab1Rows1
      },
      table4: {
        total: mockTab4Total1,
        rows: mockTab4Rows1
      }
    }
  },
  detailTab3Popup () {
    let mockDetailTab3Popup = {
      codform: faker.random.number().toString().substr(0, 1),
      desc_codform: faker.lorem.word(),
      destrevl: faker.lorem.word(),
      desc_codinst: faker.lorem.word(),
      desc_codcours: faker.lorem.word(),
      desc_codsubj: faker.lorem.word()
    }
    let mockDetailTab3PopupTable2Rows = []
    const mockChoice = [ 'A', 'B', 'C', 'D' ]
    const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
    const mockScore = [ '4', '3', '2', '1' ]
    const mockDetailTab3PopupTable2Total = 4
    for (var d = 1; d <= mockDetailTab3PopupTable2Total; d++) {
      mockDetailTab3PopupTable2Rows.push({
        grditem: d,
        grade: mockChoice[d - 1],
        qtyscor: mockScore[d - 1],
        desc_grditem: mockDescChoice[d - 1],
        definit: ''
      })
    }
    let mockDetailTab3PopupTable1GroupRows = []
    const mockDetailTab3PopupTable1Total = 3
    for (var a = 1; a <= mockDetailTab3PopupTable1Total; a++) {
      let mockDetailTab3PopupTable1ItemRows = []
      const mockDetailTab3PopupTable1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockDetailTab3PopupTable1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGrditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGrditem * mockItemQtywgt
        let mockChoiceFiltered = mockDetailTab3PopupTable2Rows.filter((choice) => {
          return choice.grditem === mockItemGrditem
        })
        let mockGrad = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrad = mockChoiceFiltered[0].grade
        }
        mockDetailTab3PopupTable1ItemRows.push({
          numitem: e,
          desc_numitem: 'description ',
          definit: 'Sub description',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          grditem: mockItemGrditem,
          grade: mockGrad,
          qtywgt: mockItemQtywgt
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockDetailTab3PopupTable1GroupRows.push({
        numgrup: a,
        desc_numgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        numitem: mockDetailTab3PopupTable1ItemRows
      })
    }

    return {
      detail: mockDetailTab3Popup,
      table1: {
        total: mockDetailTab3PopupTable1Total,
        rows: mockDetailTab3PopupTable1GroupRows
      },
      table2: {
        total: mockDetailTab3PopupTable2Total,
        rows: mockDetailTab3PopupTable2Rows
      }
    }
  },
  indexCancel () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres7de/mocker.js